export type PriceStat = "average" | "median";

export const PRICE_STAT_LABEL: Record<PriceStat, string> = {
    average: "Średnia",
    median: "Mediana"
};
export type PriceStat = "average" | "median";

export const PRICE_STAT_LABEL: Record<PriceStat, string> = {
    average: "Średnia",
    median: "Mediana"
};
